import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboard-stats" }
const _hoisted_2 = { class: "stat-content" }
const _hoisted_3 = { class: "stat-value" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = { class: "stat-content" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-content" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "stat-content" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "toolbar-date-filter" }
const _hoisted_12 = { class: "title-cell" }
const _hoisted_13 = { class: "title-text" }
const _hoisted_14 = { class: "status-cell" }
const _hoisted_15 = {
  key: 0,
  class: "probability-cell"
}
const _hoisted_16 = { class: "probability-bar" }
const _hoisted_17 = { class: "probability-text" }
const _hoisted_18 = {
  key: 1,
  class: "probability-empty"
}
const _hoisted_19 = {
  key: 0,
  class: "contact-cell"
}
const _hoisted_20 = {
  key: 1,
  class: "contact-empty"
}
const _hoisted_21 = {
  key: 0,
  class: "company-cell"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "currency-cell"
}
const _hoisted_24 = { class: "currency-value" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "date-cell" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "date-empty"
}
const _hoisted_29 = { class: "owner-cell" }
const _hoisted_30 = {
  ref: "popupBody",
  class: "popup-body-simple popup-body-modern"
}
const _hoisted_31 = { class: "form-content form-content-modern" }
const _hoisted_32 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_33 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_34 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_35 = { class: "footer-right" }
const _hoisted_36 = { class: "popup-body-modern" }
const _hoisted_37 = {
  class: "show-more-container",
  style: {"display":"flex","justify-content":"center","margin":"1px 0"}
}
const _hoisted_38 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_39 = { class: "form-footer footer-modern" }
const _hoisted_40 = {
  class: "footer-right",
  style: {"margin-top":"1px","text-align":"right"}
}
const _hoisted_41 = { class: "popup-body-simple popup-body-modern" }
const _hoisted_42 = { class: "form-content form-content-modern" }
const _hoisted_43 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_44 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_45 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_46 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_47 = { class: "footer-fixed footer-modern" }
const _hoisted_48 = { class: "footer-right" }
const _hoisted_49 = { class: "popup-body-modern" }
const _hoisted_50 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_51 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_52 = {
  class: "footer-right",
  style: {"margin-top":"20px","text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_dx_button = _resolveComponent("dx-button")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxLabel = _resolveComponent("DxLabel")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "stat-card",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.applyQuickFilter('all'))),
        title: "Vezi toate oportunitățile"
      }, [
        _cache[40] || (_cache[40] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#dbeafe"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-box",
            style: {"color":"#1e40af"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "stat-label" }, "Total Oportunități", -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.totalOpportunities), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[42] || (_cache[42] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#d1fae5"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-money",
            style: {"color":"#065f46"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "stat-label" }, "Valoare Pipeline", -1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatCurrency(_ctx.totalPipelineValue)), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "stat-card",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.applyQuickFilter('won'))),
        title: "Filtrează oportunități câștigate"
      }, [
        _cache[44] || (_cache[44] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#fef3c7"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-percent",
            style: {"color":"#78350f"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "stat-label" }, "Oportunități Câștigate", -1)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.wonCount), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "stat-card",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyQuickFilter('negotiation'))),
        title: "Filtrează oportunități în negociere"
      }, [
        _cache[46] || (_cache[46] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#fed7aa"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-chart",
            style: {"color":"#92400e"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _cache[45] || (_cache[45] = _createElementVNode("div", { class: "stat-label" }, "În Negociere", -1)),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.negotiationCount), 1)
        ])
      ])
    ]),
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": _ctx.dsSales,
      allowColumnResizing: true,
      "key-expr": "ID",
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "hover-state-enabled": true,
      "show-column-lines": false,
      allowMerging: 'Cells',
      width: "100%",
      onExporting: _ctx.onExporting,
      onRowClick: _ctx.onRowClick,
      "remote-operations": true,
      class: "grid theme-dependent",
      onContentReady: _ctx.calculateStatistics,
      onOptionChanged: _ctx.onOptionChanged,
      onRowRemoving: _ctx.onRowRemoving,
      onRowRemoved: _ctx.onRowRemoved,
      onRowPrepared: _ctx.onRowPrepared,
      onRowUpdated: _ctx.onRowUpdated
    }, {
      titleTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_12, [
          _cache[52] || (_cache[52] = _createElementVNode("i", { class: "dx-icon-box" }, null, -1)),
          _createElementVNode("span", _hoisted_13, _toDisplayString(data.value || '-'), 1)
        ])
      ]),
      statusTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", {
            class: _normalizeClass(['status-badge', _ctx.getStatusClass(data.value)])
          }, [
            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(data.value || '-'), 1)
          ], 2)
        ])
      ]),
      probabilityTemplate: _withCtx(({ data }) => [
        (data.value !== null && data.value !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "probability-fill",
                  style: _normalizeStyle({
                            width: data.value + '%',
                            backgroundColor: _ctx.getProbabilityColor(data.value)
                        })
                }, null, 4)
              ]),
              _createElementVNode("span", _hoisted_17, _toDisplayString(data.value) + "%", 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
      ]),
      contactTemplate: _withCtx(({ data }) => [
        (data.data.Contact)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[54] || (_cache[54] = _createElementVNode("i", { class: "dx-icon-user" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(data.data.Contact.Nume) + " " + _toDisplayString(data.data.Contact.Prenume), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
      ]),
      companyTemplate: _withCtx(({ data }) => [
        (data.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _cache[55] || (_cache[55] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(data.value), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_22, "-"))
      ]),
      budgetTemplate: _withCtx(({ data }) => [
        (data.value !== null && data.value !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formatCurrency(data.value)), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
      ]),
      closeDateTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_26, [
          _cache[56] || (_cache[56] = _createElementVNode("i", { class: "dx-icon-event" }, null, -1)),
          (data.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.formatDate(data.value)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_28, "-"))
        ])
      ]),
      ownerCellTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_29, [
          _cache[57] || (_cache[57] = _createElementVNode("i", { class: "dx-icon-user" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(data.displayValue || '-'), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxPager, {
          "show-page-size-selector": true,
          "allowed-page-sizes": [5, 10, 20],
          "show-info": true,
          "show-navigation-buttons": true
        }),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          "allow-search": true,
          title: "Selector coloane"
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: true }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Caută oportunitate..."
        }),
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": false,
          formats: ['xlsx', 'pdf']
        }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, { location: "before" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _cache[47] || (_cache[47] = _createElementVNode("span", { class: "filter-label" }, "Orizont:", -1)),
                  _createVNode(_component_DxDateBox, {
                    value: _ctx.startDate,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
                    type: "date",
                    "display-format": "dd/MM/yyyy",
                    onValueChanged: _ctx.applyGlobalFilter,
                    width: "130",
                    placeholder: "De la"
                  }, null, 8, ["value", "onValueChanged"]),
                  _cache[48] || (_cache[48] = _createElementVNode("span", {
                    class: "filter-label",
                    style: {"margin":"0 4px"}
                  }, "-", -1)),
                  _createVNode(_component_DxDateBox, {
                    value: _ctx.endDate,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                    type: "date",
                    "display-format": "dd/MM/yyyy",
                    onValueChanged: _ctx.applyGlobalFilter,
                    width: "130",
                    placeholder: "Până la"
                  }, null, 8, ["value", "onValueChanged"]),
                  _createVNode(_component_DxButton, {
                    icon: "trash",
                    "styling-mode": "text",
                    hint: "Resetează date",
                    onClick: _ctx.resetFilters
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
              default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                _createElementVNode("div", { class: "separator" }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_dx_button, {
                    icon: "plus",
                    type: "success",
                    onClick: _ctx.onAddClick,
                    hint: "Adauga Oportunitate"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_DxButton, {
                    icon: "refresh",
                    onClick: _ctx.onRefreshClick,
                    hint: "Reîmprospătează"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "exportButton",
              hint: "Exporta"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "columnChooserButton",
              "locate-in-menu": "auto",
              hint: "Alege Coloanele"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "searchPanel",
              "locate-in-menu": "auto"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          savingTimeout: 100,
          "storage-key": "gridOportunitatiState"
        }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxEditing, {
          "allow-deleting": true,
          "use-icons": true,
          mode: "row"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Titlu",
          caption: "Titlu Oportunitate",
          "cell-template": "titleTemplate",
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Status.Nume",
          caption: "Status",
          "cell-template": "statusTemplate",
          allowFiltering: true,
          allowSorting: true,
          "allow-header-filtering": true,
          "header-filter": { dataSource: _ctx.statusHeaderFilterDataSource }
        }, null, 8, ["header-filter"]),
        _createVNode(_component_DxColumn, {
          "data-field": "Probabilitate",
          caption: "Probabilitate Status",
          "cell-template": "probabilityTemplate",
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Contact/Nume",
          caption: "Contact",
          "cell-template": "contactTemplate",
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Contact/Prenume",
          caption: "Prenume Contact",
          visible: false,
          "allow-search": true,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Account.Nume",
          caption: "Partener",
          "cell-template": "companyTemplate",
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Sursa.Nume",
          caption: "Sursă Lead",
          visible: false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "BugetEstimat",
          caption: "Buget Estimat",
          "data-type": "number",
          format: "#,##0.00",
          "cell-template": "budgetTemplate",
          "allow-search": false,
          "calculate-cell-value": _ctx.calculateBugetEUR,
          "allow-header-filtering": false
        }, null, 8, ["calculate-cell-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "DataInchidereEstimat",
          caption: "Închidere Estimată",
          "data-type": "date",
          format: "dd/MM/yyyy",
          "cell-template": "closeDateTemplate",
          "allow-search": false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Owner",
          caption: "Responsabil",
          "cell-template": 'ownerCellTemplate',
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Note",
          caption: "Note",
          visible: false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "VenitRealizat",
          caption: "Venit Realizat",
          visible: false,
          "data-type": "number",
          "allow-search": false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataInchis",
          caption: "Data Închidere",
          visible: false,
          "allow-search": false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "UltimulStatus",
          caption: "Ultimul Status",
          visible: false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "MotivInchidere",
          caption: "Motiv Închidere",
          visible: false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Campanie.Denumire",
          visible: false,
          caption: "Campanie Marketing",
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CostEfectiv",
          caption: "Cost Efectiv",
          visible: false,
          "data-type": "number",
          "allow-search": false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ListaProduse",
          caption: "Produse",
          visible: false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Discount",
          caption: "Discount",
          visible: false,
          "data-type": "number",
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Valuta.Simbol",
          visible: false,
          caption: "Valuta",
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Curs",
          caption: "Curs",
          visible: false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Proiect.Cod",
          caption: "Proiect",
          visible: false,
          "allow-header-filtering": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataCreat",
          caption: "Data Crearii",
          visible: false,
          "allow-header-filtering": false
        })
      ]),
      _: 1
    }, 8, ["data-source", "onExporting", "onRowClick", "onContentReady", "onOptionChanged", "onRowRemoving", "onRowRemoved", "onRowPrepared", "onRowUpdated"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      showTitle: true,
      height: 615,
      width: 1350
    }, {
      title: _withCtx(() => [...(_cache[58] || (_cache[58] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare oportunitate"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează informațiile în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nouă ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_DxForm, {
              formData: _ctx.formData,
              "col-count": 2,
              "col-span": 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  "item-type": "group",
                  caption: _ctx.tabs[0],
                  "col-count": 2,
                  "css-class": "form-section-simple form-section-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItem, {
                      dataField: "Titlu",
                      "css-class": "field-full-width",
                      "col-span": 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Denumire Oportunitate" }),
                        _createVNode(_component_DxRequiredRule, { message: "Denumirea este obligatorie" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      label: { text: 'Status' },
                      "col-span": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          value: _ctx.sStatus,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sStatus) = $event)),
                          "data-source": _ctx.dsStatus,
                          "display-expr": "Nume",
                          "value-expr": "ID",
                          "show-clear-button": true,
                          placeholder: "Nou",
                          "content-template": "gridContent",
                          "read-only": true
                        }, {
                          gridContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_DxDataGrid, {
                                "data-source": _ctx.dsStatus,
                                "hover-state-enabled": true,
                                height: 280,
                                "remote-operations": true,
                                onRowClick: _ctx.onStatusRowClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxPaging, {
                                    enabled: true,
                                    "page-size": 5
                                  }),
                                  _createVNode(_component_DxFilterRow, { visible: true }),
                                  _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                  _createVNode(_component_DxSorting, { mode: "single" }),
                                  _createVNode(_component_DxColumn, {
                                    "data-field": "NrOrd",
                                    visible: false,
                                    "sort-order": "asc",
                                    "sort-index": 0
                                  }),
                                  _createVNode(_component_DxColumn, {
                                    "data-field": "Nume",
                                    caption: "Status"
                                  }),
                                  _createVNode(_component_DxColumn, {
                                    "data-field": "Pondere",
                                    caption: "Pondere (%)",
                                    width: "120"
                                  })
                                ]),
                                _: 1
                              }, 8, ["data-source", "onRowClick"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["value", "data-source"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Owner",
                      "editor-options": { readOnly: true },
                      "col-span": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Responsabil" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      "data-field": "Data",
                      "editor-type": "dxDateBox",
                      "col-span": 1,
                      "editor-options": {
                                type: 'datetime',
                                displayFormat: 'dd/MM/yyyy',
                                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                                useMaskBehavior: true
                            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Data " })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      label: { text: 'Partener' },
                      "col-span": 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Partenerul este obligatoriu" }),
                        _createVNode(_component_DxDropDownBox, {
                          value: _ctx.sPartener,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sPartener) = $event)),
                          "data-source": _ctx.dsParteneri,
                          "display-expr": "Nume",
                          "value-expr": "ID",
                          "show-clear-button": true,
                          placeholder: "Selectează partener",
                          "content-template": "gridContent",
                          "drop-down-options": { width: 500, height: 400 }
                        }, {
                          gridContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_DxDataGrid, {
                                "data-source": _ctx.dsParteneri,
                                columns: ['Nume'],
                                "hover-state-enabled": true,
                                height: 280,
                                "remote-operations": true,
                                onRowClick: _ctx.onPartenerRowClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                  _createVNode(_component_DxFilterRow, { visible: true }),
                                  _createVNode(_component_DxPaging, {
                                    enabled: true,
                                    "page-size": 5
                                  }),
                                  _createVNode(_component_DxSearchPanel, {
                                    visible: true,
                                    placeholder: "Caută..."
                                  }),
                                  _createVNode(_component_DxGridToolbar, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxButton, {
                                            icon: "plus",
                                            type: "success",
                                            height: "25px",
                                            width: "25px",
                                            onClick: _ctx.onAddNewPartener
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data-source", "onRowClick"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["value", "data-source"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, { label: { text: 'Persoană de Contact' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Persoana de contact este obligatorie" }),
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isContacteGridBoxOpened,
                          "onUpdate:opened": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isContacteGridBoxOpened) = $event)),
                          "data-source": _ctx.contactSelectat,
                          value: _ctx.sContact,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sContact) = $event)),
                          "show-clear-button": true,
                          "display-expr": "FullName",
                          "value-expr": "ID",
                          placeholder: "Selectează contact",
                          disabled: !_ctx.sPartener,
                          "drop-down-options": { width: 650, height: 400 }
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsContacts,
                              "selected-row-keys": _ctx.sContact ? [_ctx.sContact] : [],
                              "hover-state-enabled": true,
                              height: "100%",
                              onRowClick: _ctx.onContactRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Caută..."
                                }),
                                _createVNode(_component_DxColumn, {
                                  "data-field": "Nume",
                                  caption: "Nume"
                                }),
                                _createVNode(_component_DxColumn, {
                                  "data-field": "Prenume",
                                  caption: "Prenume"
                                }),
                                _createVNode(_component_DxGridToolbar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          icon: "plus",
                                          type: "success",
                                          height: "25px",
                                          width: "25px",
                                          onClick: _ctx.onAddNewContact
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "selected-row-keys", "onRowClick"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "SursaID",
                      editorType: 'dxSelectBox',
                      "editor-options": {
                                displayExpr: 'Nume',
                                valueExpr: 'ID',
                                dataSource: _ctx.dsSalesSources,
                                placeholder: 'Selectează',
                                showClearButton: true
                            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Sursa lead este obligatorie" }),
                        _createVNode(_component_DxLabel, { text: "Sursă Lead" })
                      ]),
                      _: 1
                    }, 8, ["editor-options"])
                  ]),
                  _: 1
                }, 8, ["caption"]),
                _createVNode(_component_DxFormItem, {
                  "item-type": "group",
                  caption: _ctx.tabs[3],
                  "col-span": 3,
                  "col-count": 3,
                  "css-class": "form-section-simple form-section-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItem, {
                      dataField: "BugetEstimat",
                      editorType: "dxNumberBox",
                      "editor-options": {
                                format: '#0.00',
                                showSpinButtons: true
                            }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "ProbabilitateCastig",
                      editorType: "dxSelectBox",
                      "editor-options": {
                                dataSource: _ctx.probabilityList,
                                placeholder: 'Selectează %',
                                showClearButton: true
                            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Șansa de Câștig (%)" })
                      ]),
                      _: 1
                    }, 8, ["editor-options"]),
                    _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isValutaGridBoxOpened,
                          "onUpdate:opened": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isValutaGridBoxOpened) = $event)),
                          "data-source": _ctx.valutaSelectat,
                          value: _ctx.sValuta,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sValuta) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Simbol",
                          "value-expr": "Id",
                          placeholder: "RON"
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsValuta,
                              "selected-row-keys": _ctx.sValuta ? [_ctx.sValuta] : [],
                              columns: ['Simbol'],
                              "hover-state-enabled": true,
                              height: "100%",
                              onRowClick: _ctx.onValutaRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Caută..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "selected-row-keys", "onRowClick"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      "data-field": "IntervalCumparare",
                      "editor-type": "dxSelectBox",
                      "editor-options": {
                                dataSource: _ctx.intervalList,
                                valueExpr: 'name',
                                displayExpr: 'name',
                                searchEnabled: true,
                                placeholder: 'Necunoscut',
                                showClearButton: true
                            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Interval Cumpărare" })
                      ]),
                      _: 1
                    }, 8, ["editor-options"]),
                    _createVNode(_component_DxFormItem, {
                      dataField: "DataInchidereEstimat",
                      editorType: "dxDateBox",
                      "editor-options": {
                                displayFormat: 'dd/MM/yyyy',
                                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ'
                            }
                    }),
                    _createVNode(_component_DxFormItem, {
                      label: { text: 'Campanie' },
                      "col-span": 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isCampaniiGridBoxOpened,
                          "onUpdate:opened": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isCampaniiGridBoxOpened) = $event)),
                          "data-source": _ctx.campanieSelectat,
                          value: _ctx.sCampanie,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.sCampanie) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Denumire",
                          "value-expr": "ID",
                          placeholder: "Selectează campanie",
                          "drop-down-options": { width: 450 }
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsCampaniiMarketing,
                              "selected-row-keys": _ctx.sCampanie ? [_ctx.sCampanie] : [],
                              columns: ['Denumire'],
                              "hover-state-enabled": true,
                              height: 300,
                              onRowClick: _ctx.onCampanieRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Cauta ..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "selected-row-keys", "onRowClick"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Note",
                      "editor-type": "dxTextArea",
                      "editor-options": { height: 100 },
                      "col-span": 3
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Observații" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["caption"])
              ]),
              _: 1
            }, 8, ["formData"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onSaveAdd
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ])
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isPartnerModalVisible,
      width: 1450,
      height: '90vh',
      "max-height": 800,
      "show-title": true,
      title: "Adăugare Partener Nou",
      onHiding: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isPartnerModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[59] || (_cache[59] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare partener"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile partenerului ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_DxForm, {
            ref: "newPartnerFormRef",
            "form-data": _ctx.newPartnerData,
            "col-count": 3,
            "col-span": 3
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Identitate & Fiscal",
                "col-count": 6,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CUI",
                    label: { text: 'CUI/CNP' },
                    "editor-options": _ctx.cuiOptions,
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'CUI/CNP' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Nume",
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Nume' este obligatoriu" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Fiscal",
                    "editor-type": "dxSelectBox",
                    "col-span": 4,
                    label: { text: 'Tip Fiscal' },
                    "editor-options": {
                                dataSource: _ctx.dsParteneriFiscal,
                                displayExpr: 'Nume',
                                valueExpr: 'Cod',
                                placeholder: 'Selectează Tip Fiscal',
                            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Tip Fiscal' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numar",
                    label: { text: 'Regim Comerț' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Caen",
                    label: { text: 'Cod CAEN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Owner",
                    "editor-options": { readOnly: true },
                    label: { text: 'Responsabil' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Cont",
                    label: { text: 'IBAN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Grup *' },
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.GrupID,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newPartnerData.GrupID) = $event)),
                        "data-source": _ctx.dsGrupuri,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        placeholder: "Selectează grupul",
                        "search-enabled": true,
                        "show-clear-button": true
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Zona *' },
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.ZonaID,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newPartnerData.ZonaID) = $event)),
                        "data-source": _ctx.dsZona,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        placeholder: "Selectează zona",
                        "search-enabled": true,
                        "show-clear-button": true
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Memo",
                    "col-span": 6,
                    "editor-options": { height: 80 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Sediu Social",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Strada",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Bloc",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Et",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Ap",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Țara *' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.TaraID,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newPartnerData.TaraID) = $event)),
                        "data-source": _ctx.dsPartnerTari,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează țara",
                        "search-enabled": true,
                        "show-clear-button": true,
                        onValueChanged: _ctx.onTaraChanged
                      }, null, 8, ["value", "data-source", "onValueChanged"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Județ *' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.JudetID,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newPartnerData.JudetID) = $event)),
                        "data-source": _ctx.dsPartnerJudete,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează județul",
                        "search-enabled": true,
                        "show-clear-button": true,
                        onValueChanged: _ctx.onJudetChanged
                      }, null, 8, ["value", "data-source", "onValueChanged"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Localitate",
                    "col-span": 3,
                    "editor-options": { onValueChanged: _ctx.onLocalitateChanged }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Localitate' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Adresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Domiciliu Fiscal",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CStrada",
                    "col-span": 3,
                    label: { text: 'Strada' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CNumarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CBloc",
                    "col-span": 1,
                    label: { text: 'Bl.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CScarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CEt",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAp",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Țara' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.CTaraID,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newPartnerData.CTaraID) = $event)),
                        "data-source": _ctx.dsCTari,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează țara",
                        "search-enabled": true,
                        "show-clear-button": true,
                        onValueChanged: _ctx.onCTaraChanged
                      }, null, 8, ["value", "data-source", "onValueChanged"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Județ' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.CJudetID,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newPartnerData.CJudetID) = $event)),
                        "data-source": _ctx.dsCJudete,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează județul",
                        "search-enabled": true,
                        "show-clear-button": true,
                        onValueChanged: _ctx.onCJudetChanged
                      }, null, 8, ["value", "data-source", "onValueChanged"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CLocalitate",
                    "col-span": 3,
                    label: { text: 'Localitate' },
                    "editor-options": { onValueChanged: _ctx.onCLocalitateChanged }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CCP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAdresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                visible: !_ctx.showExtendedDetails,
                "col-count": 3,
                "col-span": 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_DxButton, {
                      "element-attr": { class: 'show-more-btn' },
                      text: "Completează detalii suplimentare",
                      icon: "chevrondown",
                      type: "normal",
                      "styling-mode": "text",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showExtendedDetails = true))
                    })
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Configurare Financiară & Comericală",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, { label: { text: 'Bancă (Internă)' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sBanci,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.sBanci) = $event)),
                        "data-source": _ctx.dsBanci,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează bancă",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsBanci,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onBanciRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxGridToolbar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          icon: "plus",
                                          type: "success",
                                          height: "25px",
                                          width: "25px",
                                          onClick: _ctx.onAddNewBank
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        opened: _ctx.isValutaGridBoxOpened,
                        "onUpdate:opened": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isValutaGridBoxOpened) = $event)),
                        "data-source": _ctx.valutaSelectat,
                        value: _ctx.sValuta,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.sValuta) = $event)),
                        "show-clear-button": true,
                        "display-expr": "Simbol",
                        "value-expr": "Id",
                        placeholder: "RON"
                      }, {
                        content: _withCtx(({ data }) => [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsValuta,
                            "selected-row-keys": _ctx.sValuta ? [_ctx.sValuta] : [],
                            columns: ['Simbol'],
                            "hover-state-enabled": true,
                            height: "100%",
                            onRowClick: _ctx.onValuteRowClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys", "onRowClick"])
                        ]),
                        _: 1
                      }, 8, ["opened", "data-source", "value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "CapitalSocial" }),
                  _createVNode(_component_DxFormItem, { "data-field": "CifraAfacere" }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "NrAngajati",
                    label: { text: 'Nr. Angajați' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AdaosPret",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scadenta",
                    label: { text: 'Termen de plată' },
                    "col-span": 1,
                    "editor-options": { readOnly: !_ctx.canEditLimiteCredit }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CreditLimita",
                    label: { text: 'Limita de credit' },
                    "col-span": 1,
                    "editor-options": { readOnly: !_ctx.canEditLimiteCredit }
                  }, null, 8, ["editor-options"])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Contacte & Diverse",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Tel",
                    label: { text: 'Telefon' }
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "Fax" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Email" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Director" }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Observatii",
                    "col-span": 2,
                    "editor-options": { height: 100 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "System Flags",
                visible: _ctx.showExtendedDetails,
                "col-count": 2,
                "col-span": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTVAlaIncasare",
                    "editor-type": "dxCheckBox",
                    label: { text: 'TVA la Încasare' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "RegimSpecialTVA",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Intern",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: _ctx.handleInternChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Extern",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: _ctx.handleExternChange },
                    label: { text: 'Extern Non UE' }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "ExternUE",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: _ctx.handleExternUEChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Client",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Furnizor",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Angajat",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Activ",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTvaDefalcat",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Split TVA' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "faraScadenta",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CalculezPenalitati",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Litigiu",
                    "editor-type": "dxCheckBox"
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_DxButton, {
                text: "Salvează Compania",
                type: "success",
                onClick: _ctx.onSaveNewPartner,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined",
                disabled: _ctx.isSubmitting
              }, null, 8, ["onClick", "disabled"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isPartnerModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isContactModalVisible,
      onHiding: _cache[35] || (_cache[35] = ($event: any) => (_ctx.isContactModalVisible = false)),
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 800,
      height: 640
    }, {
      title: _withCtx(() => [...(_cache[60] || (_cache[60] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-user" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare contact"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile contactului în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_DxForm, {
              "form-data": _ctx.contactData,
              "col-count": 3,
              "col-span": 3,
              "label-alignment": "center",
              ref: "form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  "data-field": "Prenume",
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul Prenume este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Nume",
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul Nume este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Titlu",
                  label: { text: 'Funcția' },
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Funcția este obligatorie" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Partener' },
                  "col-span": 2,
                  "col-count": 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Partenerul este obligatoriu" }),
                    _createVNode(_component_DxDropDownBox, {
                      value: _ctx.sPartener,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.sPartener) = $event)),
                      "data-source": _ctx.dsParteneri,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      "show-clear-button": true,
                      placeholder: "Selectează partener",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsParteneri,
                            columns: ['Nume'],
                            "hover-state-enabled": true,
                            height: 280,
                            "remote-operations": true,
                            onRowClick: _ctx.onPartenerRowClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxScrolling, { mode: "virtual" }),
                              _createVNode(_component_DxGridToolbar, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxButton, {
                                        icon: "plus",
                                        type: "success",
                                        height: "25px",
                                        width: "25px",
                                        onClick: _ctx.onAddNewPartener
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "onRowClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["value", "data-source"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "MetodaContact",
                  label: { text: 'Metodă de Comunicare' },
                  "editor-type": "dxSelectBox",
                  "editor-options": {
                                items: _ctx.metodaContact,
                                placeholder: 'Selectează metoda de comunicare'
                            }
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxFormItem, {
                  "data-field": "TelMobil",
                  label: { text: 'Telefon' }
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Email",
                  label: { text: 'Email' }
                }),
                _createVNode(_component_DxFormItem, {
                  dataField: "Adresa",
                  label: { text: 'Adresă' },
                  "col-span": 3
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Țară' },
                  "col-span": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      "data-source": _ctx.dsTari,
                      value: _ctx.sTara,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.sTara) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      placeholder: "Selectează țara",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsTari,
                            columns: ['Nume'],
                            "remote-operations": true,
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onValueSelectedTara($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, { label: { text: 'Județ' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      opened: _ctx.isJudetGridBoxOpened,
                      "onUpdate:opened": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.isJudetGridBoxOpened) = $event)),
                      "data-source": _ctx.judetSelectat,
                      value: _ctx.sJudet,
                      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.sJudet) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      placeholder: "Selectează județul"
                    }, {
                      content: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsJudete,
                            value: _ctx.sJudet,
                            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.sJudet) = $event)),
                            columns: ['Nume'],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onValueSelectedJudet($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["opened", "data-source", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Localitate' },
                  "col-span": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      "data-source": _ctx.dsLocalitati,
                      value: _ctx.sLocalitate,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.sLocalitate) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Localitate",
                      "value-expr": "ID",
                      placeholder: "Selectează localitatea",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsLocalitati,
                            columns: ['Localitate'],
                            "remote-operations": true,
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onValueSelectedLocalitate($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Note",
                  "col-span": 3,
                  "editor-options": { height: 80 },
                  "editor-type": "dxTextArea"
                })
              ]),
              _: 1
            }, 8, ["form-data"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                disabled: !_ctx.formData.AccountID,
                onClick: _ctx.onSaveAddContact
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.isContactModalVisible = false))
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isBankModalVisible,
      width: 800,
      height: 750,
      "show-title": true,
      title: "Adăugare Bancă",
      onHiding: _cache[38] || (_cache[38] = ($event: any) => (_ctx.isBankModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[61] || (_cache[61] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-user" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare bancă"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile băncii ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.newBankData,
            "col-count": 2,
            "col-span": 2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, { "data-field": "Ordine" }),
              _createVNode(_component_DxFormItem, { "data-field": "Cod" }),
              _createVNode(_component_DxFormItem, { "data-field": "Nume" }),
              _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownBox, {
                    value: _ctx.sValute,
                    "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.sValute) = $event)),
                    "data-source": _ctx.dsValute,
                    "display-expr": "Nume",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "Selectează ",
                    "content-template": "gridContent"
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": _ctx.dsValute,
                          columns: ['Nume'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: _ctx.onValuteRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxScrolling, { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onRowClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, { "data-field": "CodIBAN" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodBIC" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodSWIFT" }),
              _createVNode(_component_DxFormItem, { "data-field": "TextFC" }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Principala",
                "editor-type": "dxCheckBox"
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Activ",
                "editor-type": "dxCheckBox"
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_DxButton, {
                text: "Salvează Banca",
                type: "success",
                onClick: _ctx.onSaveNewBank,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.isBankModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}